var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneralIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 84.375C23.2538 84.375 5.625 66.7462 5.625 45C5.625 23.2538 23.2538 5.625 45 5.625C66.7462 5.625 84.375 23.2538 84.375 45C84.375 66.7462 66.7462 84.375 45 84.375ZM45 90C69.8528 90 90 69.8528 90 45C90 20.1472 69.8528 0 45 0C20.1472 0 0 20.1472 0 45C0 69.8528 20.1472 90 45 90Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2756 28.4367C36.2123 27.9547 37.3399 28.0365 38.1972 28.6489L57.8847 42.7114C58.6238 43.2393 59.0625 44.0917 59.0625 45C59.0625 45.9083 58.6238 46.7607 57.8847 47.2886L38.1972 61.3511C37.3399 61.9635 36.2123 62.0454 35.2756 61.5633C34.3388 61.0812 33.75 60.116 33.75 59.0625V30.9375C33.75 29.884 34.3388 28.9188 35.2756 28.4367Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralIcon);
export default __webpack_public_path__ + "static/media/general-icon.4f87a67ac31cd478a96c2833ee3d152a.svg";
export { ForwardRef as ReactComponent };